import {formatText} from 'presentation/utils';
import {UseDocumentItemProps} from './types';
import {useState} from 'react';

export function useDocumentItem({id, filename, pathURL}: UseDocumentItemProps) {
	const [isDownloading, setIsDownloading] = useState(false);
	const [isOpening, setIsOpening] = useState(false);

	const handleDownload = async () => {
		if (isDownloading) return;

		setIsDownloading(true);
		try {
			const response = await fetch(pathURL);

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = `${formatText(filename).replace(/\s+/g, '')}-${id}.pdf`;
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw new Error('Erro ao buscar o PDF');
		} finally {
			setIsDownloading(false);
		}
	};

	const openPdf = async () => {
		if (isOpening) return;

		setIsOpening(true);

		try {
			window.open(pathURL);
		} catch (error) {
			throw new Error('Erro ao abrir o PDF');
		} finally {
			setIsOpening(false);
		}
	};

	return {
		isDownloading,
		isOpening,
		handleDownload,
		openPdf,
	};
}
